import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  icon?: ReactNode
  action?: ReactNode
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      {icon && <div className="text-text-tertiary">{icon}</div>}
      <div className="flex flex-col gap-1">
        <p className="t-h3 text-text-primary">{title}</p>
        {description && <p className="text-text-tertiary">{description}</p>}
      </div>
      {action}
    </div>
  )
}
